import React from "react";
import { isFunction } from "../../../../../Libs/CustomMethods/customMethods";

const AudioButton = ({ onClick }) => {
  return (
    <div
      className="d-flex align-items-center h-100 font-size-20 px-2 pointer border rounded"
      onClick={isFunction(onClick) && onClick}
    >
      <i className="mdi mdi-microphone"></i>
    </div>
  );
};
export default AudioButton;
